<template>
  <b-form>
    <base-header type="">
      <b-row>
        <b-col v-if="privilegios == 'SU'">
          <base-button type="default" block class="mb-3" @click="editarCurso()"
            >Crear nuevo Curso</base-button
          >
        </b-col>

        <b-col v-if="privilegios == 'SU' || privilegios == 'C'" >
          <base-button
            :disabled="!listGroups.length > 0"
            type="default"
            block
            class="mb-3"
            @click="editarGrupo()"
            >Crear nuevo Grupo</base-button
          >
        </b-col>
      </b-row>

      <model-nuevo-curso
        idModal="modal-curso"
        @creaNuevoCurso="creaNuevoCurso"
        :cursoSelect="selectCurso"
      />

      <model-nuevo-grupo
        idModal="modal-grupo"
        @editaGrupo="editaGrupo"
        :selectGrupo="selectGrupo"
      />

      <b-row v-if="listGroups">
        <template v-for="(item, index) in listGroups">
          <b-col
            @click="
              grupos = item.grupos;
              grupos.idCurso = item.id;
            "
            :key="index"
          >
            <base-button
              :block="true"
              @click="
                grupos = item.grupos;
                grupos.idCurso = item.id;
              "
              :type="grupos == item.grupos ? 'primary' : 'secondary'"
              >{{ getNombreCurso(item) }}

              <base-button
                v-if="privilegios != 'G'"
                class="ml-4"
                @click="editarCurso(item)"
                ><b-icon icon="pencil" aria-hidden="true"></b-icon></base-button
              ><base-button v-if="privilegios == 'SU'"
                ><b-icon icon="trash" aria-hidden="true"></b-icon
              ></base-button>
            </base-button>
          </b-col>
        </template>
      </b-row>
    </base-header>
    <hr class="mt-0 mb-4" />
    <div>
      <b-row>
        <b-col>
          <tabla-grupos
            :data="grupos"
            @editarGrupo="editarGrupo"
            @eliminarGrupo="eliminarGrupo"
          />
        </b-col>
      </b-row>
    </div>
  </b-form>
</template>
<script>
import axios from "@/directives/axios.js";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import tablaGrupos from "@/components/Tables/TablaGestionGrupos.vue";
import closeicon from "@/components/close.vue";
import modelNuevoCurso from "@/components/modals/ModalNuevoCurso.vue";
import modelNuevoGrupo from "@/components/modals/ModalNuevoGrupo.vue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

import "@/components/Spinner-Load/loader.css";
import { spinner } from "@/components/Spinner-Load/loader.js";
const loader = spinner();

export default {
  components: {
    VueBootstrapTypeahead,
    tablaGrupos,
    closeicon,
    modelNuevoCurso,
    modelNuevoGrupo,
  },
  data() {
    return {
      dataGroup: [],
      grupos: [],
      selectGrupo: undefined,
      selectCurso: undefined,
      esVisible: false,
    };
  },
  computed: {
    listGroups() {
      if (this.$store.getters.getCursosGruposCatequistas != undefined) {
        loader.close();
        return this.$store.getters.getCursosGruposCatequistas;
      } else {
        loader.open();
        this.$store.dispatch("cargarCursosGruposCatequistas");
        return [];
      }
    },
    privilegios() {
      if (this.$store.getters.getTipoPrivilegiosUsuario != undefined) {
        loader.close();
        return this.$store.getters.getTipoPrivilegiosUsuario;
      } else {
        loader.open();
        this.$store.dispatch("cargaPrivilegiosUsuario");
      }
    },
  },
  methods: {
    editarCurso(item) {
      this.selectCurso = item;
      this.$nextTick(() => {
        this.$bvModal.show("modal-curso");
      });
    },
    getNombreCurso(value) {
      var nombre = "";
      nombre = value.nombre;
      value.responsables.forEach((element) => {
        nombre += " - " + element.nombre + " " + element.apellido1;
      });
      return nombre;
    },
    eliminarGrupo(id) {
      loader.open();
      axios({
        method: "delete",
        url: `/gestionCatequesis/grupoCatequesis?id=${id}`,
        withCredentials: true,
      })
        .then((data) => {
          this.$store.dispatch("cargarCursosGruposCatequistas", data.data);
          loader.close();
          swal.fire({
            title: `Datos Eliminados Correctamente`,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          });
        })
        .catch(() => {
          swal.fire({
            title: `Error`,
            text: "Ocurrio un erro inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    eliminarCurso(id) {
      loader.open();
      axios({
        method: "delete",
        url: `/gestionCatequesis/cursoCatequesis?id=${id}`,
        withCredentials: true,
      })
        .then((data) => {
          this.$store.dispatch("cargarCursosGruposCatequistas", data.data);
          loader.close();
          swal.fire({
            title: `Datos Eliminados Correctamente`,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `Error`,
            text: "Ocurrio un erro inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    editaGrupo(grupo) {
      loader.open();
      axios({
        method: "POST",
        url: `/gestionCatequesis/grupoCatequesis`,
        withCredentials: true,
        data: grupo,
      })
        .then((data) => {
          this.$store.dispatch("cargarCursosGruposCatequistas", data.data);
          loader.close();
          swal
            .fire({
              title: `Datos Actualizados`,
              text: "Datos actualizados correctamente",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-success",
              icon: "success",
            })
            .then(() => {
              this.$nextTick(() => {
                this.$bvModal.hide("modal-grupo");
              });
              this.$bvModal.hide("modal-grupo");
            });
        })
        .catch(() => {
          loader.close();
          swal.fire({
            title: `ERROR`,
            text: "Ocurrio un erro inesperado, intentelo mas tarde",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-warning",
            icon: "warning",
          });
        });
    },
    creaNuevoCurso(nombreCurso, catequista) {
      loader.open();
      var catequistaResponsable;
      if (catequista.length > 0) {
        catequistaResponsable = catequista.find((element) => element.check);
        if(catequistaResponsable){
          catequistaResponsable = catequistaResponsable.id;
        }
      }
      axios({
        method: "post",
        url: `/gestionCatequesis/cursoCatequesis`,
        withCredentials: true,
        data: {
          id: this.selectCurso ? this.selectCurso.id : null,
          nombre: nombreCurso,
          responsable: catequistaResponsable ? catequistaResponsable : "",
        },
      })
        .then((data) => {
          this.$store.dispatch("cargarCursosGruposCatequistas", data.data);
          this.$nextTick(() => {
            loader.close();
            swal
              .fire({
                title: `Datos Actualizados`,
                text: "Datos actualizados correctamente",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success",
                icon: "success",
              })
              .then(() => {
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-curso");
                });
              });
          });
        })
        .catch(() => {
          loader.close();
        });
    },
    editarGrupo(datos) {
      this.selectGrupo = datos;
      this.$nextTick(() => {
        this.$bvModal.show("modal-grupo");
      });
    },
  },
};
</script>
<style></style>
